import axios from 'axios';
import { getRequest } from './api';
import { CurrentUser } from '@typeList/api/user';

const apiUrl: string | undefined = process.env.REACT_APP_BACKEND_API_URL;

export const axiosAuthInstance = axios.create({
  baseURL: apiUrl,
  headers: {
    'accept': 'application/json',
    'Content-Type': 'application/x-www-form-urlencoded',
  },
  withCredentials: true,
});

export interface MfaChallenge {
  challenge_id: string;
  expires_at: string;
  channel_type: string;
}

export interface AuthResult {
  status: number;
  user?: CurrentUser;
  challenge?: MfaChallenge;
}

export const Auth = async (params: object): Promise<AuthResult> => {
  const response = await axiosAuthInstance.post('/token', params);
  if (response.status === 200) {
    const userInfoResponse = await fetchCurrentUser();
    return { status: 200, user: userInfoResponse };
  }
  if (response.status === 202) {
    return { status: 202, challenge: response.data as MfaChallenge };
  }
  return { status: response.status };
};

export interface VerifyMfaPayload {
  challenge_id: string;
  code: string;
  channel_type?: string;
}

export const VerifyMfa = async (
  payload: VerifyMfaPayload
): Promise<CurrentUser> => {
  const response = await axiosAuthInstance.post('/mfa/verify', payload, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
  if (response.status === 200) {
    const userInfoResponse = await fetchCurrentUser();
    return userInfoResponse;
  }
  throw new Error('MFA verification failed');
};

export const fetchCurrentUser = async (): Promise<CurrentUser> => {
  const response = await getRequest<CurrentUser>('/user/me');
  return response;
};
